import { defineStore } from "pinia";
const useQuoteCartStore = defineStore("quoteCart", {
  state: () => ({
    quoteCart: {
      id: "",
      is_virtual: false,
      total_quantity: 0
    }
  })
});
export {
  useQuoteCartStore
};
